import { Link } from "react-router-dom";
import { container } from "tsyringe";
import ClapActionWhiteLogo from "assets/images/logo-clapaction-white.svg";
import Facebook36x36 from "assets/images/socials/Facebook36x36.svg";
import Instagram36x36 from "assets/images/socials/Instagram36x36.svg";
import Linkedin36x36 from "assets/images/socials/Linkedin36x36.svg";
import NeeedcoIcon from "assets/images/socials/neeedCo.png";
import LaDCF from "assets/images/socials/LADCF.svg";
import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import SuscribeNewsLetterButton from "components/materials/SuscribeNewsLetterButton";
import ModuleConfig from "configs/ModuleConfig";
import classes from "./classes.module.scss";

const modules = container.resolve(ModuleConfig).get().modules;

export default function Footer() {
	return (
		<footer className={classes["root"]}>
			<FooterDesign className={classes["design"]} />
			<div className={classes["content"]}>
				<LazyImage src={ClapActionWhiteLogo} alt="clapaction logo" className={classes["logo"]} />

				<div className={classes["contact-links-container"]}>
					<div className={classes["content"]}>
						<Typography type="p" size="small" weight="regular" className={classes["text"]}>
							{I18n.trslt(I18n.asset.component.footer.social_links)}
						</Typography>
						<div className={classes["social-links-container"]}>
							<Link to={"https://www.linkedin.com/company/clapaction/"} target="_blank" className={classes["social-link"]}>
								<LazyImage src={Linkedin36x36} alt="linkedin icon" className={classes["social-icon"]} />
							</Link>
							<Link to={"https://www.facebook.com/clapaction13"} target="_blank" className={classes["social-link"]}>
								<LazyImage src={Facebook36x36} alt="facebook icon" className={classes["social-icon"]} />
							</Link>
							<Link
								to={"https://www.instagram.com/clapaction_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="}
								target="_blank"
								className={classes["social-link"]}>
								<LazyImage src={Instagram36x36} alt="instagram icon" className={classes["social-icon"]} />
							</Link>
						</div>
					</div>
					<div className={classes["content"]}>
						<Typography type="p" size="small" weight="regular" className={classes["text"]}>
							{I18n.trslt(I18n.asset.component.footer.neeedco)}
						</Typography>
						<div className={classes["social-links-container"]}>
							<Link to={"https://neeedco.com/"} target="_blank" className={classes["social-link"]}>
								<LazyImage src={NeeedcoIcon} alt="neeedco icon" className={classes["social-icon"]} />
							</Link>
						</div>
					</div>

					<div className={classes["content"]}>
						<Typography type="p" size="small" weight="regular" className={classes["text"]}>
							{I18n.trslt(I18n.asset.component.footer.dcf)}
						</Typography>
						<div className={classes["social-links-container"]}>
							<Link to={"https://www.la-dcf.com/#comite"} target="_blank" className={classes["social-link"]}>
								<LazyImage src={LaDCF} alt="laDCF icon" className={classes["social-icon"]} />
							</Link>
						</div>
					</div>
				</div>

				<div className={classes["suscribe-container"]}>
					<SuscribeNewsLetterButton variant="secondary" />
				</div>

				<div className={classes["links-container"]}>
					<Link to={modules.pages.Contact.props.path} className={classes["link"]}>
						<Typography type="p" size="small" weight="regular" className={classes["text"]}>
							{I18n.trslt(I18n.asset.component.footer.contact)}
						</Typography>
					</Link>
					<Link to={I18n.asset.component.footer.faq_link} className={classes["link"]}>
						<Typography type="p" size="small" weight="regular" className={classes["text"]}>
							{I18n.trslt(I18n.asset.component.footer.faq)}
						</Typography>
					</Link>
					<Link to={modules.pages.LegalNotice.props.path} className={classes["link"]}>
						<Typography type="p" size="small" weight="regular" className={classes["text"]}>
							{I18n.trslt(I18n.asset.component.footer.legal_notice)}
						</Typography>
					</Link>
					<Link to={modules.pages.PrivacyPolicy.props.path} className={classes["link"]}>
						<Typography type="p" size="small" weight="regular" className={classes["text"]}>
							{I18n.trslt(I18n.asset.component.footer.privacy_policy)}
						</Typography>
					</Link>
					<Link to={modules.pages.TermsOfUse.props.path} className={classes["link"]}>
						<Typography type="p" size="small" weight="regular" className={classes["text"]}>
							{I18n.trslt(I18n.asset.component.footer.terms_of_use)}
						</Typography>
					</Link>
				</div>

				<Typography type="p" size="small" weight="regular" className={classes["text"]}>
					{I18n.trslt(I18n.asset.component.footer.copyright, {
						year: new Date().getFullYear().toString(),
					})}
				</Typography>
			</div>
		</footer>
	);
}

function FooterDesign(props: { className?: string }) {
	return (
		<svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="1440" height="80" viewBox="0 0 1440 80" fill="none">
			<path d="M0 37.7154C0 37.7154 437.973 0 720 0C1002.03 0 1440 37.7154 1440 37.7154V80H0V37.7154Z" fill="#0A0A0A" />
		</svg>
	);
}
